import { defineStore } from 'pinia'

export default defineStore('wallet', {
  state: () => ({
    address: '',
    web3: null,
  }),
})